import script from "./payment-success.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-success.vue?vue&type=script&setup=true&lang=ts"

import "./payment-success.vue?vue&type=style&index=0&id=6c7d1d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7d1d1a"]])

export default __exports__